import React from 'react';
import RoleVerification from '../components/RoleVerification';

const RoleVerificationPage = () => {
  return (
    <div className="space-y-6">
      <div className="card">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Role Verification</h1>
        <p className="text-gray-600">
          This tool verifies that you have the correct Chrome admin role permissions 
          required to use this application. It checks your OAuth scopes, domain access, 
          role assignments, and application permissions.
        </p>
      </div>
      
      <RoleVerification />
    </div>
  );
};

export default RoleVerificationPage;
